(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["delivery-products"] && !Shopify.designMode) return;
  try {
    
(function() {
  function pad(n) { return String(n).padStart(2, '0'); }

  function updateCountdown(el) {
    var endDate = new Date(el.dataset.end);
    var display = el.querySelector('.dp-card__countdown-display');
    if (!display) return;

    function tick() {
      var now = new Date();
      var diff = endDate - now;
      if (diff <= 0) {
        display.textContent = 'Ended';
        return;
      }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      if (days > 0) {
        display.textContent = days + 'd ' + pad(hours) + 'h ' + pad(mins) + 'm';
      } else {
        display.textContent = pad(hours) + 'h ' + pad(mins) + 'm ' + pad(secs) + 's';
      }
    }
    tick();
    setInterval(tick, 1000);
  }

  document.querySelectorAll('.dp-card__countdown[data-end]').forEach(updateCountdown);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
